import { object } from "superstruct";

import GiftRegistryWithItemsSchema from "./GiftRegistryWithItemsSchema";

const SharedRegistryResponseSchema = object({
    giftRegistryWithItems: GiftRegistryWithItemsSchema,
});

export default SharedRegistryResponseSchema;
